const NETWORK_ERROR_PATTERN = /(failed to fetch|fetch failed|networkerror|network request failed|load failed|connexion.*(refus|interromp)|fallback)/i;

export const getUserFacingError = (
  error,
  fallback = "Une erreur est survenue. Réessayez.",
) => {
  const message = String(error?.message || error || "").trim();
  if (!message) return fallback;
  if (NETWORK_ERROR_PATTERN.test(message)) {
    return "Connexion momentanément indisponible. Réessayez.";
  }
  return message;
};

